<div class="wrapper" [class.custom-scroll]="isDrsite">
  <div class="container px-0">

    <div class="form-group" *ngIf="flowType == '' || IslandeFromQRCode || IsLandFromSurvey">
      <div class="btn-group d-flex w-100" id="checkin" role="group" aria-label="Basic example" [ngClass]="{'mt-5': IslandeFromQRCode || IsLandFromSurvey}">
        <button type="button"
                class="btn flex-fill"
                [ngClass]="isName ? 'btn-primary' : 'btn-outline-primary'"
                (click)="ChangeCheckinType('name')">
          {{'verifypatient.name'|translate}}
        </button>
        <button type="button"
                class="btn flex-fill"
                [ngClass]="isCell ? 'btn-primary' : 'btn-outline-primary'"
                (click)="ChangeCheckinType('cell')">
          {{'verifypatient.cell/email'|translate}}
        </button>
        <button type="button"
                class="btn flex-fill"
                [ngClass]="isScanLicense ? 'btn-primary' : 'btn-outline-primary'"
                (click)="ChangeCheckinType('scan')">
          {{'verifypatient.license'|translate}}
        </button>
      </div>
    </div>

    <div *ngIf="isDob">
      <h5 *ngIf="flowType != ''" class="title fw-bold text-center mb-4" style="font-size:21px"
          [ngClass]="{'mt-5': isForLabOrder}">
        {{
    flowType == 'appointment'
    ? ('existingPatientLogin.flowtypeAppointment' | translate) + ' ' + (providername || 'Unknown Provider')
    : flowType == 'laborder'
    ? 'Provide following details to print lab/imaging order'
    : ('existingPatientLogin.flowtypePayment' | translate)
        }}
      </h5>

      <h5 *ngIf="flowType =='' && !IsLandFromSurvey" class="title fw-bold text-center mb-4" style="font-size:21px"
          [ngClass]="{'mt-4': IslandeFromQRCode}">
        {{'existingPatientLogin.flowtypeCheckin'| translate}}
      </h5>

      <h5 *ngIf="flowType =='' && IsLandFromSurvey" class="title fw-bold text-center mb-4 mt-4" style="font-size:21px">
        {{'afterVisitSurvey.verifyDetails'|translate}}
      </h5>

      <div class="px-2 pb-3">
        <form [formGroup]="loginForm">
          <div class="form-row">
            <div class="col-md-12" *ngIf="flowType != 'laborder' && isName">
              <div class="form-group ">
                <div class="mb-2 border-bottom">
                  <label class="fw-bold" style="font-size:20px;">
                    {{'existingPatientLogin.existingPatientLogin_firstName'|translate}}<span class="text-danger">*</span>
                  </label>
                  <input style="font-size:20px !important;" type="text" class="form-control text-capitalize border-0"
                         placeholder="{{'existingPatientLogin.existingPatientLogin_firstNameplaceholder'| translate}}"
                         formControlName="firstname" [ngStyle]="{'border' : getloginForm.firstname.invalid
                && getloginForm.firstname.touched && getloginForm.firstname.errors!.required ? '1px solid red' : ''}"
                         maxlength="35" (input)="ValidatePersonalInfo($event,'firstname')" />
                </div>
                <div class="mb-2">
                  <span *ngIf="getloginForm.firstname.invalid && getloginForm.firstname.touched
               && getloginForm.firstname.errors!.required" class="err">
                    {{'existingPatientLogin.existingPatientLogin_firstnamerequired'|translate}}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-12" *ngIf="flowType != 'laborder' && isName">
              <div class="form-group ">
                <div class="mb-2 border-bottom">
                  <label class="fw-bold" style="font-size:20px;">
                    {{'existingPatientLogin.existingPatientLogin_lastName'|translate }}<span class="text-danger">*</span>
                  </label>

                  <input style="font-size:20px !important;" type="text"
                         class="form-control text-capitalize border-0 ltr-component"
                         placeholder="{{'existingPatientLogin.existingPatientLogin_lastNameplaceholder'| translate}}"
                         formControlName="lastname" [ngStyle]="{'border' : getloginForm.lastname.invalid
                && getloginForm.lastname.touched && getloginForm.lastname.errors!.required ? '1px solid red' : ''}"
                         maxlength="35" (input)="ValidatePersonalInfo($event,'lastname')" />

                </div>
                <div class="mb-2">
                  <span *ngIf="getloginForm.lastname.invalid && getloginForm.lastname.touched
                && getloginForm.lastname.errors!.required" class="err">
                    {{'existingPatientLogin.existingPatientLogin_lastnamerequired'|translate}}
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-2 ml-1 fw-semibold" style="font-size:18px" *ngIf="isCell">
              <span [class.err]="loginForm.errors?.emailOrCellRequired && loginForm.touched">
                {{'verifypatient.emailCellError' | translate}}
              </span>
            </div>
            <div class="col-md-6 col-lg-6" *ngIf="isCell">
              <div *ngIf="!isDrsiteCheckoutNotes">
                <div class="form-group border-bottom mb-2">
                  <label style="font-size:20px;" class="fw-bold">
                    {{'RegistrationPage.cell.label'|translate}}<span class="text-danger">**</span>
                  </label>
                  <div class="position-relative " [ngClass]="isDrsite ? 'codeverified_blue' : 'codeverified'">
                    <input style="font-size:20px !important;" type="text"
                           placeholder="{{'RegistrationPage.cell.placeholder' | translate}}"
                           class="form-control custom-input border-0" formControlName="cellPhone"
                           (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')"
                           maxlength="14" />
                  </div>

                </div>
                <div class="mb-2">
                  <span *ngIf="isNotValidPhone" class="err">{{'RegistrationPage.cell.error' | translate}}</span>
                </div>

              </div>
            </div>
            <div class="col-md-6 col-lg-6" *ngIf="isCell">
              <div *ngIf="!isDrsiteCheckoutNotes">
                <div class="form-group border-bottom mb-2 ">

                  <label style="font-size:20px;" class="fw-bold">
                    {{'RegistrationPage.email.label'|translate}}<span class="text-danger">**</span>

                  </label>
                  <div class="position-relative " [ngClass]="isDrsite ? 'codeverifiedEmail_blue' : 'codeverifiedEmail'">

                    <input style="font-size:20px !important;" type="email"
                           placeholder="{{'RegistrationPage.email.placeholder' | translate}}"
                           class="form-control custom-input border-0" formControlName="EmailAddress"
                           [ngStyle]="{'border' : !isValidEmail ? '1px solid red' : ''}"
                           (input)="validateEmailAddress($event.target)" />
                  </div>
                </div>
                <div class="mb-2">
                  <span class="err"
                        *ngIf="">
                    {{ 'RegistrationPage.email.required' | translate }}
                  </span>
                  <span *ngIf="!isValidEmail" class="err">{{'RegistrationPage.email.error' | translate}}</span>
                </div>
              </div>
            </div>
            <!--<div class="err mb-2 ml-1" *ngIf="loginForm.errors?.emailOrCellRequired && loginForm.touched">
              {{'verifypatient.emailCellError' | translate}}
            </div>-->


            <div class="col-md-12">
              <div class="form-group">
                <div class="mb-2 border-bottom fw-bold">
                  <label style="font-size:20px;">
                    {{'verifypatient.month'|translate}}<span class="text-danger">*</span>
                  </label>
                  <div class="position-relative border-0 form-select-custom"
                       [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                    <select formControlName="dobMonth" style="font-size:20px !important;"
                            class="form-control text-capitalize border-0" placeholder="Month" (change)="updateDays($event)">
                      <option value="" disabled selected>{{'verifypatient.select_month'|translate}}</option>
                      <option *ngFor="let month of months; let i = index" [value]="i + 1">{{ month }}</option>
                    </select>
                  </div>
                </div>
                <div class="mb-2">
                  <span id="f-zip-err" class="err"
                        *ngIf="loginForm.controls['dobMonth'].touched && loginForm.controls['dobMonth'].invalid">
                    <span class="err"
                          *ngIf=" loginForm.controls['dobMonth'].errors && loginForm.controls['dobMonth'].errors.required">{{'existingPatientLogin.month_error_msg'|translate}}.</span>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <div class="mb-2 border-bottom fw-bold">
                  <label style="font-size:20px;">
                    {{'verifypatient.date_label'|translate}}<span class="text-danger">*</span>
                  </label>
                  <div class="position-relative border-0 form-select-custom"
                       [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                    <select formControlName="dobDay" style="font-size:20px !important;"
                            class="form-control text-capitalize border-0" placeholder="Day">
                      <option value="" disabled selected>{{'verifypatient.select_date'|translate}}</option>
                      <option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</option>
                    </select>
                  </div>
                </div>
                <div class="mb-2">
                  <span *ngIf="loginForm.controls['dobDay'].touched && loginForm.controls['dobDay'].invalid">
                    <span class="err"
                          *ngIf=" loginForm.controls['dobDay'].errors && loginForm.controls['dobDay'].errors.required">
                      {{'existingPatientLogin.day_error_msg'|translate}}.
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <div class="mb-2 border-bottom fw-bold">
                  <label style="font-size:20px;">
                    {{'verifypatient.year'|translate}}<span class="text-danger">*</span>
                  </label>
                  <div class="position-relative border-0 form-select-custom "
                       [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                    <select formControlName="dobyear" style="font-size:20px !important;"
                            class="form-control text-capitalize border-0" (change)="updateDays($event)">
                      <option value="" disabled selected>{{'verifypatient.select_year'|translate}}</option>
                      <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
                <div class="mb-2">
                  <span id="f-zip-err" class="err"
                        *ngIf="loginForm.controls['dobyear'].touched && loginForm.controls['dobyear'].invalid">
                    <span class="err"
                          *ngIf="loginForm.controls['dobyear'].errors && loginForm.controls['dobyear'].errors.required">
                      {{'existingPatientLogin.year_error_msg'|translate}}.
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4" *ngIf="flowType =='appointment'">
              <div *ngIf="!isDrsiteCheckoutNotes">
                <div class="form-group border-bottom mb-2 ">

                  <label style="font-size:20px;" class="fw-bold">
                    {{'RegistrationPage.email.label'|translate}}<span class="text-danger">*</span>

                  </label>
                  <div class="position-relative " [ngClass]="isDrsite ? 'codeverifiedEmail_blue' : 'codeverifiedEmail'">

                    <input style="font-size:20px !important;" type="email"
                           placeholder="{{'RegistrationPage.email.placeholder' | translate}}"
                           class="form-control custom-input border-0" formControlName="email"
                           [ngStyle]="{'border' : !isValidEmail ? '1px solid red' : ''}"
                           (input)="validateEmailAddress($event.target)" />
                  </div>
                </div>
                <div class="mb-2">
                  <span class="err"
                        *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].hasError('required')">
                    {{ 'RegistrationPage.email.required' | translate }}
                  </span>
                  <span *ngIf="!isValidEmail" class="err">{{'RegistrationPage.email.error' | translate}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4" *ngIf="flowType =='appointment'">
              <div *ngIf="!isDrsiteCheckoutNotes">
                <div class="form-group border-bottom mb-2">
                  <label style="font-size:20px;" class="fw-bold">
                    {{'RegistrationPage.cell.label'|translate}}<span class="text-danger">*</span>
                  </label>
                  <div class="position-relative " [ngClass]="isDrsite ? 'codeverified_blue' : 'codeverified'">
                    <input style="font-size:20px !important;" type="text"
                           placeholder="{{'RegistrationPage.cell.placeholder' | translate}}"
                           class="form-control custom-input border-0" formControlName="cell"
                           (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')"
                           maxlength="14" />
                  </div>

                </div>
                <div class="mb-2">
                  <span *ngIf="isNotValidPhone" class="err">{{'RegistrationPage.cell.error' | translate}}</span>
                  <span *ngIf="loginForm.controls['cell'].invalid && loginForm.controls['cell'].touched && loginForm.controls['cell'].errors!.required"
                        class="err">
                    {{'RegistrationPage.cell.required' | translate}}
                  </span>
                </div>

              </div>
            </div>
          </div>
          </form>
      </div>
      </div>
      <div *ngIf="isScanLicense && !isDobChecked">
        <!-- Scan driving card start-->
        <div class="mt-5">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="card">
                <div class=" p-0 ">
                  <div class="mycontainer">
                    <div class="box">


                      <button type="button" class="btn btn-sm upload-btn w-100 px-0 d-flex justify-content-center align-items-center">
                        <input type="file" id="file" class="d-none" (change)="onChangeFileFront($event)"
                               accept="image/png, image/gif, image/jpeg, image/jpg, application/pdf">

                        <!--<label for="file" class="w-100 d-flex align-items-center m-0 justify-content-start justify-content-md-center">

    <svg width="45" height="45" viewBox="0 0 45 45" fill="#5bc5d0" xmlns="http://www.w3.org/2000/svg" class="me-3">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="#5bc5d0" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="#5bc5d0" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="#5bc5d0" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="#5bc5d0" />
    </svg>

    <span class="text-container d-flex flex-column">
      <span class="fw-semibold text-info" style="font-size: 18px;">
        Scan Driver's License
      </span>
      <span class="text-muted" style="font-size: 14px;margin-left:5px">
        Fast verification using your camera
      </span>
    </span>

  </label>-->
                        <label for="file" class="w-100 d-flex flex-column align-items-center m-0">
                          <svg width="55" height="55" viewBox="0 0 45 45" fill="##10469f" xmlns="http://www.w3.org/2000/svg" class="mb-2">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="#10469f" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="#10469f" />
                          </svg>

                          <span class="text-container d-flex flex-column align-items-center text-center">
                            <span class="fw-semibold text-info" style="font-size: 20px;">
                              {{'verifypatient.scan_title'|translate}}
                            </span>
                            <span class="text-muted" style="font-size: 17px; margin-left:0;">
                              {{'verifypatient.scan_title_text'|translate}}
                            </span>
                          </span>
                        </label>
                      </button>

                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <span class="text-muted" style="font-size: 14px;">
                  {{'verifypatient.scan_disclaimer'|translate}}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isScanLicense && isDobChecked" class="form-row">

        <div class="col-md-12 mt-5">
          <!--<div class="devider mb-4">
        <span>{{ 'careteam.or' | translate }}</span>
      </div>-->
          <div class="col-md-12">
            <div class=" pb-2 border-bottom">

              <button type="button" class="btn btn-sm upload-btn w-100 px-0 d-flex justify-content-center align-items-center">
                <input type="file" id="file" class="d-none" (change)="onChangeFileFront($event)"
                       accept="image/png, image/gif, image/jpeg, image/jpg">

                <label for="file" class="w-100 d-flex justify-content-center align-items-center">
                  <span class="file-button d-flex flex-column align-items-center justify-content-center">


                    <svg *ngIf="!isFrontPhotoUpload" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="black" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="black" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="black" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="black" />
                    </svg>


                    <div *ngIf="isFrontPhotoUpload" class="mb-3">
                      <img class="img-fluid" [src]="defaultImagefront" height="155" width="231">
                    </div>


                    <span *ngIf="!isFrontPhotoUpload" class="text-muted mt-2">
                      {{'verifypatient.driving_license' | translate}}
                    </span>
                    <span *ngIf="isFrontPhotoUpload" class="text-muted mt-2">
                      {{'verifypatient.driving_license_retake' | translate}}
                    </span>
                  </span>
                </label>
              </button>
            </div>
            <div class="mt-3">
              <span class="text-muted" style="font-size: 14px;">
                {{'verifypatient.retakeInfoHome'|translate}}
              </span>
            </div>
          </div>
        </div>
      </div>


      <!-- Scan driving card end -->





    </div>

  <!-- two factor auth modal  -->
  <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="verifycode">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">SMS Verification</h5>
          <button type="button" (click)="clearTimer()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-2">We've sent an OTP code to your {{linkType}} {{phoneLink}}.<br>Please enter it below:</p>
          <div class="align-items-center d-flex verifycode">
            <div class="form-group mb-0">
              <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
              </ng-otp-input>
            </div>
          </div>
          <div *ngIf="!otpEntered" class="err">
            <span style="color: red;">OTP Required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <span class="text-center mr-auto">&nbsp; Resend Code in {{m}}:{{s}}</span>
          <button type="button" [disabled]="remainingTime > 0"
                  [ngClass]="remainingTime === 0 ? 'btn btn-outline-primary btn-sm' : 'btn btn-secondary btn-sm'"
                  (click)="isSendingOTP ? null : SendOTP()">
            Resend Code
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--(click)="flowType == 'payment' ? LoginPatient() : (isDrsite ? onAddScheduleAppointment() : RegistorPatient())"-->
<footer *ngIf="!IslandeFromQRCode && !isForLabOrder && !IsLandFromSurvey" class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <a class="btn" [ngClass]="isDrsite ? 'blue-btn-outline' : 'btn-outline-primary'" type="button"
         (click)="backPage()">{{'button.back'|translate}}</a>
      <a class="btn " [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'" *ngIf="flowType !=''" type="button"
         (click)="handleNextClick()">{{'button.next'|translate}}</a>
      <!-- <a class="btn " [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'" *ngIf="flowType !=''" type="button"
        (click)="flowType =='payment' ? LoginPatient() :RegistorPatient()">{{'button.next'|translate}}</a> -->
      <!-- <a class="btn btn-primary" type="button" (click)="RegistorPatient()">{{'button.next'|translate}}</a> -->
      <!-- <a class="btn btn-primary" *ngIf="flowType !=''" type="button"
        (click)="onAddScheduleAppointment()">{{'button.next'|translate}}</a> -->
      <a class="btn btn-primary" *ngIf="flowType ==''" type="button"
         (click)="onSubmit()">{{'button.next'|translate}}</a>
    </div>
  </div>
</footer>

<footer *ngIf="IslandeFromQRCode || isForLabOrder || IsLandFromSurvey">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
        <button *ngIf="IslandeFromQRCode || IsLandFromSurvey" class="btn btn-primary w-100" type="button" (click)="onSubmit()">
          {{'verifypatient.get_started'|translate}}
        </button>
        <button *ngIf="!IslandeFromQRCode && !IsLandFromSurvey" class="btn btn-primary w-100" type="button" (click)="handleNextClick()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</footer>




<!--<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_linkexiting">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-body p-4 text-center">
              <h5 class="font-weight-bolder mb-3 text-danger"><strong>Incorrect information, Please try again.</strong></h5>
              <p class="mb-3">In case of any queries, contact your practice
                  <span *ngIf="!practice_phone">office</span>
                  <span *ngIf="practice_phone">at <a href={{phoneLink}} class="text-info">{{practice_phone}}</a></span>.</p>
                  <button type="button" data-toggle="modal" data-dismiss="modal" id="isNotValid_linkexiting" class="btn btn-primary ">OK</button>
          </div>
      </div>
  </div>
</div>-->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_linkexiting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.Incorrect_information'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.Credentials_do_not_match_our_records'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!practice_phone">{{'verifypatient.office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'verifypatient.at'|translate}} <a href={{phoneLink}} [ngClass]="isDrsite ? 'text-info-blue':'text-info'"
                                                style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>
          {{'verifypatient.if_you_need_assistance'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="isNotValid_linkexiting" class="btn"
                [ngClass]="isDrsite ? 'blue-btn' :'btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<!--first name last name modal-->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="enable_Names">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>
            {{
'existingPatientLogin.moreThanOnePatientExistDob'|
            translate
            }}
          </strong>
        </h5>
        <!--<h6 class="font-weight-bolder mb-3 ">{{'existingPatientLogin.moreThanOnePatientExistbody'|translate}}</h6>-->
        <!--<p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!practice_phone">{{'verifypatient.office'|translate}}</span>
          <span *ngIf="practice_phone">{{'verifypatient.at'|translate}} <a href={{phoneLink}} class="text-info">{{practice_phone}}</a></span> {{'verifypatient.if_you_need_assistance'|translate}}
        </p>-->
        <button type="button" data-toggle="modal" data-dismiss="modal" id="enable_Names"
                [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<!--first name last name modal-->


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="ismorethenonepatient">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.moreThanOnePatientExistHeading'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.moreThanOnePatientExistbody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}} <a href={{phoneLink}} class="text-info"
                                                                            style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="ismorethenonepatient"
                [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="noAppointmentFound">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.noAppointmentheading'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.noAppointmentBody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}}<a href={{phoneLink}} class="text-info"
              style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="noAppointmentFound"
                [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="alreadycheckin">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <!-- It seems like you have already checked-in for your appointment with Wayne, Best at 04:15PM.-->
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.already_checkedin_msg'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.noAppointmentBody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}} <a href={{phoneLink}} class="text-info"
                                                                            style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="alreadycheckin"
                [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade in modal-alert bd-example-modal-sm" id="No_due" tabindex="-1" role="dialog"
     data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.No_due_balance'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-center">{{'verifypatient.No_outstanding_balance'|translate}}</p>
        <div class="text-center">
          <button type="button" data-toggle="modal" data-dismiss="modal" id="No_due"
                  [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
            {{'button.ok'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfoLicense-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.Incorrect_information'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.dob_notmatchedHome'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.dob_notmatched_bodyHome'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="cardMissing-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.cardRequired'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.cardRequired_body'|translate}}</h6>
        <!--<p class="mb-3">
          Please upload the correct license or enter your DOB manually.
        </p>-->
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="scanFail-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'verifypatient.unable_scan'|translate}}</strong></h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.unable_scan_textHome'|translate}}</h6>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary " (click)="ChangeCheckinType('name')">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade in modal-alert bd-example-modal-sm" id="noLabFoundModal" tabindex="-1" role="dialog"
     data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Lab/Imaging Order Not Found </strong></h5>
        <p class="mb-3">Your lab/imaging order was not found. Please contact your provider’s office.</p>
        <div class="text-center">
          <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary">
            {{'button.ok'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
